export default {
  "selectCodeNewListPage": "/backstageApi/account/backstage/device/code/selectListPage",
  "selectCodeOldListPage": "/backstageApi/account/backstage/device/code/selectCodeOldListPage"

}



// WEBPACK FOOTER //
// ./src/api/device/deviceCode.js